// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';

import { LabInformation } from '../../types/Model';
import { RootAction, actionCreatorsList } from '../rootActionCreator';

export interface LabInformationState {
  labInformation: Record<number, LabInformation>;
  isLoading: boolean;
  isInformationFetching: boolean;
  isBuying: boolean;
  isEnding: boolean;
  error?: Error;
}

const { getLabInformationActions, buyLabActions, endLabActions } = actionCreatorsList;

export const initialState: LabInformationState = {
  labInformation: {},
  isLoading: false,
  isInformationFetching: false,
  isBuying: false,
  isEnding: false,
};

export default function (state = initialState, action: RootAction):LabInformationState {
  let newState = state;
  switch (action.type) {
    // getLabInformationActions
    case getType(getLabInformationActions.request): {
      newState = {
        ...state,
        isInformationFetching: !action.payload.preventLoading,
        error: undefined,
      };
      break;
    }
    case getType(getLabInformationActions.success): {
      const { payload } = action;
      const lab = payload.labInformation;
      newState = {
        ...state,
        isInformationFetching: false,
        labInformation: { ...state.labInformation, [lab.id]: lab },
      };
      break;
    }
    case getType(getLabInformationActions.failure): {
      newState = {
        ...state,
        isInformationFetching: false,
        error: action.payload.error,
      };
      break;
    }
    // buyLabActions
    case getType(buyLabActions.request): {
      newState = {
        ...state,
        isBuying: true,
      };
      break;
    }
    case getType(buyLabActions.success): {
      newState = {
        ...state,
        isBuying: false,
      };
      break;
    }
    case getType(buyLabActions.failure): {
      newState = {
        ...state,
        isBuying: false,
      };
      break;
    }
    // endLabActions
    case getType(endLabActions.request): {
      newState = {
        ...state,
        isEnding: true,
      };
      break;
    }
    case getType(endLabActions.success): {
      newState = {
        ...state,
        isEnding: false,
      };
      break;
    }
    case getType(endLabActions.failure): {
      newState = {
        ...state,
        isEnding: false,
      };
      break;
    }
  }

  if (newState !== state) {
    newState = {
      ...newState,
      isLoading: newState.isInformationFetching || newState.isBuying
    }
  }

  return newState;
}
